enum ShiftDirection {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
}

export default ShiftDirection;
